import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { MODE } from '@v2/pages/machines/common/enums';
import { connect } from 'react-redux';
import { getNCFileByPartId } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getPartByID } from '@reducers/parts';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import NCFileListOrSingleItem from '@v2/pages/machines/modules/now/components/NC-file/components/NCFileListOrSingleItem';

interface PartDetailsNCFileProps {
  ncFiles: ReducerEntityWithLoadingState<NCFileSearchItem[]>;
  ncFileId: number | null;
}

const PartDetailsNCFileComponent: FC<PartDetailsNCFileProps> = ({
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  ncFiles,
  operationsSearch,
  ncFileId,
}) => {
  const title = useTitle();

  const { ncFileDataLoading } = usePartDetails({
    clearTools,
    getNCFileByPartId,
    getTools,
    getProductionBatchByPart,
    updateHeaderConfig,
    getPartByID,
    operationsSearch,
    getAllNcFiles: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
        <NCFileListOrSingleItem
          ncFileData={ncFiles.data}
          ncFileDataLoading={!ncFiles.wasLoaded}
          ncFileId={ncFileId}
          ncFileDataLoadingForList={ncFileDataLoading}
        />
    </DetailsPageWrapper>
  );
};

const PartDetailsNCFile = connect(({ details: { ncFiles, ncFileId } }) => ({ ncFiles, ncFileId }), {
  getNCFileByPartId,
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  operationsSearch,
})(PartDetailsNCFileComponent);

export { PartDetailsNCFile };
